import dayjs from "dayjs";
import {ENV} from "./enum";

export const defaultDialog = {
    open: false,
    title: '',
    body: '',
    buttonText: '',
    handle: null,
    useInput: false,
    confirmText: ''
}

// UserInfo
export const defaultUserSearchParams = {
    type: 'pid',
    value: ''
}

// CS
export const defaultCSSearchParam = {
    type: -1,
    state: -1,
    etc: 0,
    searchValue: ''
}

export const stateList = [
    {
        text: '미처리',
        value: 0,
        color: 'gray',
    },
    {
        text: '처리 완료',
        value: 1,
        color: 'green',
    },
    {
        text: '진행 중',
        value: 2,
        color: 'red',
    },
];

// ServerInfo
export const defaultServerInfo = {
    state: 0,
    begin: dayjs().unix(),
    end: dayjs().unix(),
    csvPathList: [],
    ios: '',
    aos: '',
    gameServerList: [],
    versions: {
        aos: [],
        ios: [],
    },
}

export const defaultVersion = {
    isIOS: true,
    isAOS: true,
    isRecommendedUpdate: false,
    version: '',
    csvVersion: '',
    gameServer: 0,
    csvPath: 0
}

export const defaultRegister = {
    id: "",
    email: "",
    password: "",
    name: "",
}

export const defaultLogin = {
    id: "",
    password: "",
    env: ENV.DEVELOP,
}
